module.exports = __webpack_public_path__ + "static/media/searchButton.f04b297e.svg";